module.exports = __webpack_public_path__ + "../resources/images/illustration_to_me-127f6d5aceef690fa82be98c21fc9dbf.svg";